/**
 * Because Android browser does not support keyboard event's event.key
 * so this set of keycode is prepared in that case
 *
 * event.keycode is deprecated but its usage is still necessary
 */
export const ARROW_LEFT = 37;
export const ARROW_UP = 38;
export const ARROW_RIGHT = 39;
export const ARROW_DOWN = 40;
export const ENTER = 13;
export const PAGE_UP = 33;
export const PAGE_DOWN = 34;
export const END = 35;
export const HOME = 36;
export const KEYCODE_TO_KEY = {
  [ARROW_LEFT]: 'ArrowLeft',
  [ARROW_UP]: 'ArrowUp',
  [ARROW_RIGHT]: 'ArrowRight',
  [ARROW_DOWN]: 'ArrowDown',
  [ENTER]: 'Enter',
  [PAGE_UP]: 'PageUp',
  [PAGE_DOWN]: 'PageDown',
  [END]: 'End',
  [HOME]: 'Home'
};

export const getEventKey = (event: KeyboardEvent): string => event.key || KEYCODE_TO_KEY[event['keyCode'] || event['which']];

/**
 * Check if the event's key is related to one of the provided key codes
 */
export const isKey = (event: KeyboardEvent | string, keyCodes: Array<number>): boolean => {
  if (!keyCodes || !keyCodes.length) {
    return false;
  }

  let eventKey: string = '';
  if(typeof event === 'string') {
    eventKey = event;
  } else {
    eventKey = getEventKey(event);
  }
  return keyCodes.some(code => KEYCODE_TO_KEY[code] === eventKey);
};
